import React from 'react';
import { Card, Table, Badge } from 'react-bootstrap';
import { formatCurrency } from '../../utils/formatters';

const AccountDetailCard = ({ customer }) => {
  return (
    <Card className="shadow mb-4">
      <Card.Header>
        <h3 className="mb-0">Account Detail</h3>
      </Card.Header>
      <Card.Body>
        <Table size="sm" className="detail-table mb-0">
          <tbody>
            <tr>
              <th>Account Number</th>
              <td>{customer?.accountId}</td>
            </tr>
            <tr>
              <th>Account Status</th>
              <td>
                {customer?.latestServiceAgreement?.status ? (
                  <Badge bg={customer.latestServiceAgreement.status === 'Active' ? 'success' : 'secondary'}>
                    {customer.latestServiceAgreement.status}
                  </Badge>
                ) : (
                  <span className="text-muted">N/A</span>
                )}
              </td>
            </tr>
            <tr>
              <th>Current Balance Due</th>
              <td>{formatCurrency(customer?.currentBalanceDue, 'Not Available')}</td>
            </tr>
            <tr>
              <th>Payoff Balance</th>
              <td>{formatCurrency(customer?.payoffBalance, 'Not Available')}</td>
            </tr>
            <tr>
              <th>Risk for Disconnect</th>
              <td>
                <Badge bg={customer?.eligibleForDisconnect ? 'danger' : 'success'}>
                  {customer?.eligibleForDisconnect ? 'Yes' : 'No'}
                </Badge>
              </td>
            </tr>
            <tr>
              <th>Disconnect Order</th>
              <td>
                <Badge bg={customer?.accountPendingDisconnect ? 'danger' : 'success'}>
                  {customer?.accountPendingDisconnect ? 'Yes' : 'No'}
                </Badge>
              </td>
            </tr>
            <tr>
              <th>Active Pay Plan</th>
              <td>
                <Badge bg={customer?.hasActivePaymentPlan ? 'warning' : 'secondary'} text={customer?.hasActivePaymentPlan ? 'dark' : undefined}>
                  {customer?.hasActivePaymentPlan ? 'Yes' : 'No'}
                </Badge>
              </td>
            </tr>
            <tr>
              <th>Payment Arrangement</th>
              <td>
                <Badge bg={customer?.hasActivePaymentArrangement ? 'warning' : 'secondary'} text={customer?.hasActivePaymentArrangement ? 'dark' : undefined}>
                  {customer?.hasActivePaymentArrangement ? 'Yes' : 'No'}
                </Badge>
              </td>
            </tr>
            <tr>
              <th>Pledges Received</th>
              <td>
                {customer?.appliedPledgeTypes?.length > 0
                  ? customer.appliedPledgeTypes.join(', ')
                  : <span className="text-muted">None</span>}
              </td>
            </tr>
            <tr>
              <th>Energy Discount</th>
              <td>
                {customer?.currentDiscountPercentage != null
                  ? `${customer.currentDiscountPercentage}%`
                  : <span className="text-muted">None</span>}
              </td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default AccountDetailCard;
